//@ts-ignore
import { get } from '@mindtickle/api-helpers';

export const fetchLoginStatus = async (sessionId: string) => {
  try {
    const { response } = await get(
      {
        url: '/wapi/auth',
      },
      {
        headers: {
          'x-token': sessionId,
        },
      }
    );
    return response?.login?.error?.status !== '403';
  } catch (errors) {
    console.error(errors); // eslint-disable-line
    return false;
  }
};
